import { appendFirstBlocks } from './utils/appendFirstBlocks.js';
import { appendSecondBlocks } from './utils/appendSecondBlocks.js';
import { getMatrixFromXLSX } from './utils/getMatrixFromXLSX.js';
import { matrixToBlocks } from './utils/matrixToBlocks.js';

export function hgParseMicromeritics(blob) {
  let result = {};
  const matrix = getMatrixFromXLSX(blob);
  const parsed = matrixToBlocks(matrix);
  // blocks 0 contains meta information
  appendFirstBlocks(parsed[0], result);
  // blocks 1 contains data
  appendSecondBlocks(parsed[1], result);

  return result;
}
